import type { CustomerOrderStatus } from '@/api';
import type { BadgeTone } from '@/ui';

/** Цвет бейджа статуса заказа 1С - по ближайшему статусу отгрузки макета. */
export const STATUS_TONES: Record<CustomerOrderStatus, BadgeTone> = {
  NotAgreed: 'approval',
  ToFulfil: 'preparing',
  ToShip: 'delivery',
  Closed: 'completed',
};
